/** POS-I378: English count text with the right form: plural(1, 'category', 'categories') is 'category'. For translated text use i18next count keys (_one / _other). */
export function plural(count: number, one: string, other: string): string {
  return count === 1 ? one : other;
}

/** '1 category', '3 categories'. */
export function countOf(count: number, one: string, other: string): string {
  return count + ' ' + plural(count, one, other);
}
